// Cart add-ons, kept out of the cart until checkout.
//
// The two protections are real products, but putting them in the cart as the
// shopper flips a switch is what made every earlier version fragile: the
// lines had to be hidden, they shifted the positions the theme addresses its
// own rows by, every tap meant a write and a re-render, and the two raced
// each other.
//
// So nothing is written while the shopper is shopping. A switch is a flag in
// sessionStorage, the figure on screen is the cart's own total plus whatever
// is switched on, and the lines go in with one request at the moment the
// checkout form is submitted — where the wait costs nothing, because the page
// is leaving anyway.
//
// Loaded from the layout rather than from the snippet: with an empty cart the
// cart summary is not rendered at all, and the markup that arrives with the
// first item comes in through a morph, which never runs the scripts it
// carries. So the behaviour has to already be on the page, waiting.
(function () {
  if (window.__cartUpsell) return;
  window.__cartUpsell = true;

  var last = null;
  var afterCart = null;
  var afterMarkup = null;
  var leaving = false;
  var swept = false;

  function root() {
    return document.querySelector('[data-cart-upsell]');
  }

  /* ---------------------------------------------------------------- money */

  function group(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function fmt(cents) {
    var box = root();
    var pattern = (box && box.dataset.cuMoney) || '{{amount}}';

    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, function (whole, name) {
      var value = cents / 100;

      if (name === 'amount_no_decimals') return group(value, 0, ',', '.');
      if (name === 'amount_with_comma_separator') return group(value, 2, '.', ',');
      if (name === 'amount_no_decimals_with_comma_separator') return group(value, 0, '.', ',');
      if (name === 'amount_with_apostrophe_separator') return group(value, 2, "'", '.');
      if (name === 'amount_no_decimals_with_space_separator') return group(value, 0, ' ', ',');
      if (name === 'amount_with_space_separator') return group(value, 2, ' ', ',');
      return group(value, 2, ',', '.');
    });
  }

  var totalSelectors = [
    '[ref="cartTotal"]',
    '.cart__checkout-total',
    '.cart-totals__total-value'
  ];

  // The count is left alone: nothing of ours is in the cart, so the theme's
  // own figure is already right.
  function writeTotals(cents) {
    // The money pattern lives on the block. Without the block there is nothing
    // of ours in play either, so the theme's own figure is already the right
    // one - and rewriting it here would only strip its currency off.
    if (!root()) return;

    totalSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var text = fmt(cents);
        if (el.textContent !== text) el.textContent = text;
      });
    });
  }

  /* --------------------------------------------------------- what is where */

  function read(item) {
    try {
      return JSON.parse(item.dataset.cuVariants);
    } catch (error) {
      return [];
    }
  }

  function handles() {
    var box = root();
    var all = box && box.dataset.cuAll ? box.dataset.cuAll.split(',') : [];
    return all.filter(Boolean);
  }

  // The products this add-on is offered with; null means anything.
  function targetsOf(item) {
    var raw = (item.dataset.cuTargets || '*').trim();
    if (raw === '*') return null;
    return raw.split(',').filter(Boolean);
  }

  function eligible(cart, item) {
    var targets = targetsOf(item);
    if (!targets) return true;

    return cart.items.some(function (line) {
      return targets.indexOf(line.handle) > -1;
    });
  }

  // The total a bracket is measured against. Add-ons are skipped even though
  // they should not be there at all: a cart left over from the version that
  // did put them in must not read a bracket off its own add-ons.
  function baseTotal(cart) {
    var skip = handles();

    return cart.items.reduce(function (sum, line) {
      return skip.indexOf(line.handle) > -1 ? sum : sum + line.line_price;
    }, 0);
  }

  function baseFor(cart, item) {
    var targets = targetsOf(item);
    if (!targets) return baseTotal(cart);

    return cart.items.reduce(function (sum, line) {
      return targets.indexOf(line.handle) > -1 ? sum + line.line_price : sum;
    }, 0);
  }

  function wanted(item, total) {
    var variants = read(item);
    if (!variants.length) return null;

    var box = root();
    var cuts = (box ? box.dataset.cuThresholds || '' : '')
      .split(',')
      .map(function (n) {
        return parseInt(n, 10);
      })
      .filter(function (n) {
        return !isNaN(n);
      });

    var index = 0;
    for (var i = 0; i < cuts.length; i++) {
      if (total >= cuts[i]) index = i + 1;
    }

    return variants[Math.min(index, variants.length - 1)];
  }

  /* ------------------------------------------------- the shopper's choice */

  // Held for the session and nowhere else. It never reaches the server,
  // because until checkout there is nothing on the server to hold it against
  // — which is the whole point: no write, nothing to race, nothing to undo.
  function isOff(handle) {
    try {
      return sessionStorage.getItem('cu_off_' + handle) === '1';
    } catch (error) {
      return false;
    }
  }

  function remember(handle, off) {
    try {
      if (off) sessionStorage.setItem('cu_off_' + handle, '1');
      else sessionStorage.removeItem('cu_off_' + handle);
    } catch (error) {
      /* private browsing: the choice holds for this page and no further */
    }
  }

  function onByDefault() {
    var box = root();
    return !box || box.dataset.cuDefault !== 'false';
  }

  function isOn(handle) {
    return isOff(handle) ? false : onByDefault();
  }

  // One entry per add-on, never one per row: the drawer and the cart page
  // both render the block, and counting a switch twice would both double the
  // figure on screen and add the line twice at checkout.
  function each(cart, step) {
    var seen = {};

    document.querySelectorAll('[data-cu-item]').forEach(function (item) {
      var handle = item.dataset.cuHandle;
      if (seen[handle]) return;
      if (!isOn(handle) || !eligible(cart, item)) return;

      seen[handle] = true;
      var pick = wanted(item, baseFor(cart, item));
      if (pick) step(pick, handle);
    });
  }

  function shownTotal(cart) {
    var extra = 0;

    each(cart, function (pick) {
      extra += pick.price;
    });

    return baseTotal(cart) + extra;
  }

  function chosen(cart) {
    var picks = [];

    each(cart, function (pick) {
      picks.push({ id: pick.id, quantity: 1 });
    });

    return picks;
  }

  /* ------------------------------------------------------------- the page */

  function paint(cart) {
    last = cart;

    document.querySelectorAll('[data-cu-item]').forEach(function (item) {
      var fit = eligible(cart, item);
      var hide = fit ? '' : 'none';
      if (item.style.display !== hide) item.style.display = hide;
      if (!fit) return;

      var toggle = item.querySelector('[data-cu-toggle]');
      var on = isOn(item.dataset.cuHandle) ? 'true' : 'false';
      if (toggle && toggle.getAttribute('aria-checked') !== on) {
        toggle.setAttribute('aria-checked', on);
      }

      var pick = wanted(item, baseFor(cart, item));
      var price = item.querySelector('[data-cu-price]');
      if (pick && price) {
        var text = '(' + pick.money + ')';
        if (price.textContent !== text) price.textContent = text;
      }
    });

    writeTotals(shownTotal(cart));
  }

  function readCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function post(path, body) {
    return fetch(window.Shopify.routes.root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return response.json();
    });
  }

  // Carts left behind by the version that kept the add-ons as lines, along
  // with the refusal it recorded against them. Cleared once, quietly, so a
  // shopper mid-session is not charged for a line no switch controls any
  // more. After that there is never anything to find.
  function clearOld(cart) {
    if (swept) return;
    swept = true;

    var mine = handles();
    var updates = {};
    var attributes = {};
    var found = false;

    cart.items.forEach(function (line) {
      if (mine.indexOf(line.handle) > -1) {
        updates[line.variant_id] = 0;
        found = true;
      }
    });

    Object.keys(cart.attributes || {}).forEach(function (key) {
      if (key.indexOf('cu_off_') === 0 && cart.attributes[key]) {
        attributes[key] = '';
        found = true;
      }
    });

    if (!found) return;

    post('cart/update.js', { updates: updates, attributes: attributes })
      .then(readCart)
      .then(paint)
      .catch(function () {});
  }

  function sync() {
    return readCart()
      .then(function (cart) {
        clearOld(cart);
        paint(cart);
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------- the switch */

  function flip(item) {
    var handle = item.dataset.cuHandle;
    remember(handle, isOn(handle));

    if (last) paint(last);
    else sync();
  }

  // Captured, so the figures move on this tap rather than after every other
  // listener on the page has had its turn. Nothing is requested, so there is
  // nothing to wait for: the switch and the total move together, now.
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var toggle = event.target.closest('[data-cu-toggle]');
      if (!toggle) return;

      var item = toggle.closest('[data-cu-item]');
      if (!item) return;

      event.preventDefault();
      flip(item);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter' && event.key !== 'Spacebar') return;
    if (!event.target || !event.target.closest) return;

    var toggle = event.target.closest('[data-cu-toggle]');
    if (!toggle) return;

    var item = toggle.closest('[data-cu-item]');
    if (!item) return;

    event.preventDefault();
    flip(item);
  });

  /* ----------------------------------------------------------- the checkout */

  function isCheckout(form, submitter) {
    if (!form || form.tagName !== 'FORM') return false;
    if (!submitter || submitter.name !== 'checkout') return false;
    return (form.getAttribute('action') || '').indexOf('/cart') > -1;
  }

  // The one write of the whole thing. Submission is a native browser event on
  // a plain submit button that the theme binds nothing to, so it can be held
  // and let go again — unlike the quantity controls, which go through the
  // theme's own event system and cannot be intercepted from here.
  document.addEventListener(
    'submit',
    function (event) {
      if (leaving) return;

      var submitter = event.submitter || document.activeElement;
      var form = event.target;
      if (!isCheckout(form, submitter)) return;
      if (!last) return;

      var picks = chosen(last);
      if (!picks.length) return;

      event.preventDefault();

      // Fail open. An add-on that could not be added is a sale lost, which is
      // a great deal better than a shopper who cannot pay at all — and the
      // amount charged then falls below what was shown, never above it.
      post('cart/add.js', { items: picks })
        .catch(function () {})
        .then(function () {
          leaving = true;
          if (form.requestSubmit) form.requestSubmit(submitter);
          else submitter.click();
        });
    },
    true
  );

  /* -------------------------------------------------------------- upkeep */

  document.addEventListener('cart:update', function () {
    clearTimeout(afterCart);
    afterCart = setTimeout(sync, 60);
  });

  // Markup only. Writing a total replaces a text node, which is itself a
  // childList change: counting those would have this watcher answer its own
  // corrections for as long as they were needed.
  function marked(record) {
    for (var i = 0; i < record.addedNodes.length; i++) {
      if (record.addedNodes[i].nodeType === 1) return true;
    }
    return false;
  }

  new MutationObserver(function (records) {
    if (!last) return;

    for (var i = 0; i < records.length; i++) {
      if (!marked(records[i])) continue;

      clearTimeout(afterMarkup);
      afterMarkup = setTimeout(function () {
        if (last) paint(last);
      }, 50);
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });

  function seed() {
    var box = root();

    if (box && box.dataset.cuCart) {
      try {
        var cart = JSON.parse(box.dataset.cuCart);
        if (cart && cart.items) paint(cart);
      } catch (error) {
        /* fall through to the fetch */
      }
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seed);
  } else {
    seed();
  }
})();
